import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UserRouteTrackingService {

  private LAST_AT_PAGE: string = "lastatpage";

  constructor() {
  }

  getLastAtPage() {
    return sessionStorage.getItem(this.LAST_AT_PAGE) ?? "";
  }

  isLastPageAt(): 'cardstatus' | 'email' {
    const lastPageAt = this.getLastAtPage();
    // console.log({ lastPageAt });
    if (lastPageAt.includes("cardstatus")) {
      return 'cardstatus';
    } else {
      return 'email';
    }
  }

  setLastAtPage(page: string) {
    sessionStorage.setItem(this.LAST_AT_PAGE, page);
  }

  setLastAtCardStatusPage() {
    this.setLastAtPage('cardstatus');
  }

  setLastAtEmailPage() {
    this.setLastAtPage('email');
  }
}
